export default __webpack_public_path__ + "static/media/image-speaker-zx7.82dc33d6.jpg";